export const FIELD_LABEL = "si.lead_gen_filters.group.staticListsToExclude.field_label";
export const DROPDOWN_BUTTON = "si.lead_gen_filters.staticListsToExclude.dd_button";
export const DROPDOWN_PLACEHOLDER = "si.common.search";
export const SELECT_ALL_LABEL = "si.lead_gen_filters.staticListsToExclude.selected_all_label";
